module.exports = __webpack_public_path__ + "img/dckap-logo.6d1e2fec.jpg";